import { Property, Type } from '@dipscope/type-manager';
import KTile, { KPosition, KTileDTO, KTilePos, Place, toPlace } from './KTile';
import { HexaTopology, KTileNbs } from './HexaTolopogy';
import 'reflect-metadata';

@Type({ injectable: true, discriminant: 'KTileData' })
export class KTileData {
  // keys are KTilePos strings, one tile amps to multiple positions
  @Property([String, KTile])
  map: Map<KTilePos, KTile> = new Map();

  // keys are Place keys - TODO - use triangle positions for performace improvement on overlap ???
  @Property([String, String])
  openPlaces: Set<string> = new Set();

  @Property()
  topology: HexaTopology;

  constructor(topology: HexaTopology) {
    this.topology = topology;
  }

  keys() {
    return Array.from(this.map.keys());
  }

  values() {
    return Array.from(new Set(Array.from(this.map.values())));
  }

  set(place: Place, tile: KTile) {
    // set all triangle positions
    place.positions.forEach((pos) => {
      if (this.map.has(pos.toString())) {
        console.warn('place already exists', pos.toString());
      }
      this.map.set(pos.toString(), tile);
    });
    //this.updateOpenPlaces();
  }

  removeTile(tileDTO: KTileDTO) {
    tileDTO.place.positions.forEach((pos) => {
      if (this.map.has(pos.toString())) {
        this.map.delete(pos.toString());
      }
    });
    //this.updateOpenPlaces();
  }

  getByPos(pos: KTilePos) {
    return this.map.get(pos);
  }

  getById(id: number) {
    return Array.from(this.values()).find((t) => t.id === id);
  }

  // there is an overlap if the positions of the two places have at least one common position
  placesOverlap(p0: Place, p1: Place): boolean {
    return p0.positions.map((p) => p.toString()).some((p) => new Set(p1.positions.map((p) => p.toString())).has(p));
  }

  getOverlappedTile(place: Place): KTile | null {
    for (const t of this.values()) {
      if (this.placesOverlap(t.place, place)) {
        return t;
      }
    }
    return null;
  }

  // TODO - why is this buggy?
  getOverlappedTileByPosition(position: KPosition): KTile | null {
    const kPosKey = position.toString();
    for (const t of this.values()) {
      /*
      if (t.place.toString().includes(kPosKey)) {
        return t;
      }
      */
      if (t.place.positions.some((p) => p.toString() === position.toString())) {
        return t;
      }
    }
    return null;
  }

  updateOpenPlaces() {
    this.openPlaces = new Set();

    // add free nbs places for all tiles
    Array.from(this.values()).forEach((tile) => {
      tile.place.positions.forEach((newPos) => {
        // get nb places
        const nbPlaces = this.topology.nbPlacesAll(newPos);
        nbPlaces.forEach((place: Place) => {
          // check if not already in openplaces !!
          if (!this.openPlaces.has(place.toString())) {
            //  check if doesnt overlap with existing tile in map
            const t = this.getOverlappedTile(place);
            if (!t) this.openPlaces.add(place.toString());
          }
        });
      });
    });
  }

  getTileNbs(place: Place): KTileNbs {
    const nbs: KTileNbs = { nbs: new Map() };

    // find nb triangle places of place
    const nbPositions = this.topology.nbPositions(place);
    Array.from(nbPositions.entries()).forEach(([originalPos, takenPositions]) => {
      for (let i = 0; i < takenPositions.length; i++) {
        // check if that triangle place overlaps with a tile
        // use optimized version for checking place-position overlap - its just a string search
        const takenPos: KPosition = takenPositions[i];
        const takenPosKey = takenPos.toString();
        // TODO is this buggy?
        // const tile = this.getOverlappedTileByPosition(takenPos);
        const tile = this.getOverlappedTile(new Place('triangle', [takenPos]));
        if (tile && tile.place.toString() !== place.toString() && !nbs.nbs.has(takenPosKey)) {
          nbs.nbs.set(takenPosKey, { originalPos: originalPos, nbTile: tile });
        }
      }
    });
    return nbs;
  }
}
